// extracted by mini-css-extract-plugin
export var active = "styles-module--active--f1cf3";
export var bound = "styles-module--bound--b1690";
export var circle = "styles-module--circle--43c46";
export var description = "styles-module--description--56c86";
export var icon = "styles-module--icon--7658e";
export var image = "styles-module--image--d95f3";
export var image1 = "styles-module--image1--4ffec";
export var image2 = "styles-module--image2--3cc82";
export var image3 = "styles-module--image3--e733d";
export var image4 = "styles-module--image4--b872e";
export var image_wrap = "styles-module--image_wrap--729af";
export var item = "styles-module--item--99a5a";
export var item_inner = "styles-module--item_inner--a6869";
export var link_mob = "styles-module--link_mob--11f33";
export var link_pc = "styles-module--link_pc--e76bd";
export var list = "styles-module--list--90f4c";
export var mainImage = "styles-module--mainImage--b695e";
export var message = "styles-module--message--6a04f";
export var num = "styles-module--num--ded05";
export var show = "styles-module--show--0c538";
export var side = "styles-module--side--8ff04";
export var sideImgs = "styles-module--sideImgs--c805c";
export var svg = "styles-module--svg--23ab8";
export var text = "styles-module--text--d9794";